import React from "react";

class CustomMode extends React.Component {
  constructor(props) {
    super(props);
    this.data = null;
  }

  static mapStateToProps = state => {
    const { currentModeType } = state.modeReducer;
    const { mousePosX, mousePosY, isMouseDown } = state.mouseReducer;
    const { pencilModeColor } = state.pencilModeReducer;
    return {
      currentModeType,
      mousePosX,
      mousePosY,
      isMouseDown,
      pencilModeColor
    };
  };
}

CustomMode.defaultProps = {
  onDataUpdate: () => {}
};

export default CustomMode;
